export const pink50 = "#fbebf5";
export const pink100 = "#fae1f1";
export const pink200 = "#f5c3e4";
export const pink300 = "#f0a6d7";
export const pink400 = "#eb88ca";
export const pink500 = "#e66bbd";
export const pink600 = "#e05ba8";
export const pink700 = "#da4c95";
export const pink800 = "#d43c81";
export const pink900 = "#cf2d6e";
export const pink1000 = "#b91250";
export const pinkA100 = "#fac0f1";
export const pinkA200 = "#f2a0de";
export const pinkA400 = "#d9359c";
export const pinkA500 = "#c60867";
export const pinkA1000 = "#502541";
